"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEDDVariables = void 0;
const client_1 = require("@apollo/client");
const use_edd_variables_graphql_1 = require("./use-edd-variables.graphql");
const AccountContext_1 = require("contexts/AccountContext");
const helpers_1 = require("@/edd/common/helpers");
const react_1 = require("react");
const useEDDVariables = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const getEDDConfig = (0, client_1.useQuery)(use_edd_variables_graphql_1.GET_EDD_VARIABLES, {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        variables: { accountId: account.id },
        fetchPolicy: 'network-only',
        skip: !(account === null || account === void 0 ? void 0 : account.id)
    });
    const { error, loading, data, refetch } = getEDDConfig;
    const eddVariables = (data === null || data === void 0 ? void 0 : data.estimatedDeliveryDateVariables) || [];
    const sortedVars = (0, react_1.useMemo)(() => (0, helpers_1.sortVariablesAsc)(eddVariables), [eddVariables]);
    return {
        error,
        loading,
        variables: sortedVars,
        refetch
    };
};
exports.useEDDVariables = useEDDVariables;
